<template>
    <div class="vue-iframe-modal">
        <modal :id="modalId" :name="modalId" width="90%" :maxWidth="950" :adaptive="true" height="auto" :scrollable="true" @before-close="handleClose">
            <div class="modal-inner-wrapper">
                <a class="close-button" href="" @click.prevent="close"></a>
                <iframe :src="iframeSrc" frameborder="0"></iframe>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    name: "IframeModal",

    props: ['modalBus'],

    data() {
        return {
            iframeSrc: ''
        }
    },

    mounted() {
        this.modalBus.$on('show-iframe-modal', (payload) => {
            this.iframeSrc = payload.iframeSrc;

            this.show();
        });
    },

    computed: {
        modalId() {
            return _.uniqueId('iframe-modal-');
        }
    },

    methods: {
        show() {
            document.documentElement.style.overflowY = "hidden"
            document.documentElement.style.height = "100vh"

            this.$modal.show(this.modalId);
        },

        close() {
            this.$modal.hide(this.modalId);
        },

        handleClose() {
            document.documentElement.style.overflowY = "auto"
            document.documentElement.style.height = "auto"
        }
    }
}
</script>